import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.create-credit-card-bill.views.CreditCardBillForm`

export default defineMessages({
  creditCardLabel: {
    id: `${scope}.creditCardLabel`,
    defaultMessage: 'Credit card',
  },
  creditCardProviderLabel: {
    id: `${scope}.creditCardProviderLabel`,
    defaultMessage: 'Credit card provider',
  },
  paymentMethodLabel: {
    id: `${scope}.paymentMethodLabel`,
    defaultMessage: 'Payment methods',
  },
  paymentMethodPlaceholder: {
    id: `${scope}.paymentMethodPlaceholder`,
    defaultMessage: 'Select a payment method',
  },
  paymentMethodRequiredError: {
    id: `${scope}.paymentMethodRequiredError`,
    defaultMessage: 'Payment method is required',
  },
  addMethodButton: {
    id: `${scope}.addMethodButton`,
    defaultMessage: 'Add method',
  },
  dateLabel: {
    id: `${scope}.dateLabel`,
    defaultMessage: 'Date',
  },
  dueDateLabel: {
    id: `${scope}.dueDateLabel`,
    defaultMessage: 'Due date',
  },
  dueDateRequiredError: {
    id: `${scope}.dueDateRequiredError`,
    defaultMessage: 'Due date is required',
  },
  dueUponReceipt: {
    id: `${scope}.dueUponReceipt`,
    defaultMessage: 'Due upon receipt',
  },
  net30: {
    id: `${scope}.net30`,
    defaultMessage: 'NET30',
  },
  net45: {
    id: `${scope}.net45`,
    defaultMessage: 'NET45',
  },
  net60: {
    id: `${scope}.net60`,
    defaultMessage: 'NET60',
  },
  net90: {
    id: `${scope}.net90`,
    defaultMessage: 'NET90',
  },
  paymentTermsLabel: {
    id: `${scope}.paymentTermsLabel`,
    defaultMessage: 'Payment terms',
  },
  clearButton: {
    id: `${scope}.clearButton`,
    defaultMessage: 'Clear',
  },
  invoiceAttachmentTitle: {
    id: `${scope}.invoiceAttachmentTitle`,
    defaultMessage: 'Invoice attachment',
  },
  uploadButton: {
    id: `${scope}.uploadButton`,
    defaultMessage: 'Upload',
  },
  maxFileSizeText: {
    id: `${scope}.maxFileSizeText`,
    defaultMessage: 'Max file size 25.0 MB',
  },
  attachToItemsButton: {
    id: `${scope}.attachToItemsButton`,
    defaultMessage: 'Attach to items',
  },
  removeInvoiceAriaLabel: {
    id: `${scope}.removeInvoiceAriaLabel`,
    defaultMessage: 'Remove {name}',
  },
  matchedItemsTitle: {
    id: `${scope}.matchedItemsTitle`,
    defaultMessage: 'Matched items',
  },
  notesLabel: {
    id: `${scope}.notesLabel`,
    defaultMessage: 'Credit card bill notes',
  },
  approvalGroupLabel: {
    id: `${scope}.approvalGroupLabel`,
    defaultMessage: 'Approval group',
  },
  approvalGroupPlaceholder: {
    id: `${scope}.approvalGroupPlaceholder`,
    defaultMessage: 'Select approval group',
  },
  approverLabel: {
    id: `${scope}.approverLabel`,
    defaultMessage: 'Approver',
  },
  approverPlaceholder: {
    id: `${scope}.approverPlaceholder`,
    defaultMessage: 'Select next approver',
  },
  approverRequiredError: {
    id: `${scope}.approverRequiredError`,
    defaultMessage: 'Approver is required',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  submitButton: {
    id: `${scope}.submitButton`,
    defaultMessage: 'Submit for approval',
  },
})
